import React, { useEffect, useState } from 'react';
import { getDictationBaseUrl } from '../../../Config/AxiosInstance';
import { TitleRow, ContainerRow, AddButton } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { useSelector } from 'react-redux';
import MediumCard from '../../CustomComponents/MediumCard';
import { Col, Row, notification, Checkbox, Button, Dropdown } from 'antd';
import { dashboardContents } from './DashboardConfig';
import { StyledPrimaryButton } from './styledComponents';
import { getTokenForUser } from '../../../Apis/Auth';
import { Link } from 'react-router-dom';
import PageTitle from '../../../Utils/PageTitle';
import { GetCount } from '../../../Apis/Dashboard';
import { StyledDashboardCardContainer } from '../NewDashboard/styledComponent';
import DashboardCard from '../NewDashboard/DashboardCard';
import { DownOutlined } from '@ant-design/icons'; // ✅ FIXED import
import { getJobBoardsUser, postJobBoardsUser } from '../../../Apis/JobBoard';
// import { complianceDashboardContents } from './ComplianceDashboardConfig';

import { getListofJobs } from '../../../Apis/JobBoard';
import ComplianceCard from './ComplianceCard';
import { GetAdminJobCount } from '../../../Apis/Jobs';
import Spinner from '../../CustomComponents/Spinner';
import { useHistory } from 'react-router-dom';
import { StyledFCardContainer } from './styledComponents';
import { getUserNotificationDashboard } from '../../../Apis/User';
import FacilityStatusCard from '../NewDashboard/FacilityStatusCard';
import { SettingOutlined } from '@ant-design/icons';
import { getSuperAdminDashboardConfig } from './AdminDashboardConfig';
import {
  FolderOpenOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
const doctorPrivilege = new Map([
  ['TRANSCRIPTION_ONLY', 'transcriptionist'],
  ['REVIEWER_ONLY', 'reviewer'],
  ['TRANSCRIPTION_REVIEWER', 'transcriptionist'],
  ['NONE', 'none']
]);

const Dashboard = onFilterApply => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const user = useSelector(state => state.userReducer);
  const [loading, setLoading] = useState(false);
  const [dashboardLoading, setdashboardLoading] = useState(true);
  const [dashboardItems, setDashboardItems] = useState();
  const [dashboardData, setDashboardData] = useState([]);
  const [pageSizeOpenJobs, setPageSizeOpenJobs] = useState();
  const [pageSizeCompleted, setPageSizeCompleted] = useState();
  const [tempBoardList, setTempBoardList] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const [isApplyingFilters, setIsApplyingFilters] = useState(false);

  const [pageSizeUnbilled, setPageSizeUnbilled] = useState();
  const [pageSizeIncomplete, setPageSizeIncomplete] = useState();
  const [pageSizeOpen14, setPageSizeOpen14] = useState();
  const [pageSizeIncomplete14, setPageSizeIncomplete14] = useState();
  const [pageSizeIncomplete1Month, setPageSizeIncomplete1Month] = useState();
  const [pageSizeAllJobs, setPageSizeAllJobs] = useState();
  const [pageSizeOpenJobsOlderThan7Days, setPageSizeOpenJobsOlderThan7Days] = useState();
  // const [pageSizeInCompleteJobs, setPageSizeInCompleteJobs] = useState();
  const [boardList, setBoardList] = useState([]);
  const [dashboardValues, setDashboardValues] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const notificationStatus = useSelector(state => state.notificationReducer);
  const history = useHistory();
  const [filters, setFilters] = useState({
    openJobs: true,
    completedJobs: true,
    unfilledJobs: true
  });
  const userData = JSON.parse(localStorage.getItem('user'));
  const handleCheckboxChange = (id, checked) => {
    setTempBoardList(prev =>
      prev.map(board =>
        board.id === id ? { ...board, selected: checked } : board
      )
    );
  };

  // const handleApply = () => {
  //   const selectedBoards = boardList.filter(b => b.selected);
  //   console.log('✅ Selected dashboard elements:', selectedBoards);
  //   // You can now render or filter dashboard tiles accordingly
  // };

  // ✅ Checkbox toggle handler
  // const handleCheckboxChange = (id, isChecked) => {
  //   setBoardList(prev =>
  //     prev.map(board =>
  //       board.id === id ? { ...board, selected: isChecked } : board
  //     )
  //   );
  // };

  // ✅ Handle Apply
  // const handleApply = async () => {
  //   const selectedBoards = boardList.map(board => ({
  //     boardName: board.boardName,
  //     boardFilter: board.boardFilter,
  //     selected: board.selected
  //   }));

  //   for (const board of selectedBoards) {
  //     const sanitizedBoard = {
  //       boardName: board.boardName,
  //       boardFilter: {
  //         statuses: board.boardFilter.statuses || [],
  //         doctorIds: board.boardFilter.doctorIds || [],
  //         facilityIds: board.boardFilter.facilityIds || [],
  //         billerIds: board.boardFilter.billerIds || [],
  //         workType: board.boardFilter.workType || '',
  //         patientName: board.boardFilter.patientName || '',
  //         jobNumber: board.boardFilter.jobNumber || '',
  //         createdFrom: board.boardFilter.createdFrom ?? 0,
  //         createdTill: board.boardFilter.createdTill ?? 0,
  //         relativeDaysForCreatedFrom:
  //           board.boardFilter.relativeDaysForCreatedFrom ?? 0
  //       }
  //     };

  //     postJobBoardsUser(sanitizedBoard)
  //       .then(response => {
  //         if (response.data.success) {
  //           // Adjust this based on your API structure
  //           notification['success']({
  //             message: 'Updated',
  //             description: response.data.message
  //           });
  //         } else {
  //           notification['error']({
  //             message: 'Failed',
  //             description: response.data.message
  //           });
  //         }
  //       })
  //       .catch(error => {
  //         console.error('Error fetching job board data:', error);
  //         // message.error('Failed to load job data');
  //       });
  //   }
  // };
  const fetchCountsForSelectedBoards = async boards => {
    const now = Date.now();
    const boardConfigs = [
      {
        boardName: 'Open Jobs',
        apiCall: () => getListofJobs(openJobs, 0, 20, '', '', true),
        setter: setPageSizeOpenJobs
      },
      {
        boardName: 'EMR Submitted Jobs',
        apiCall: () => getListofJobs('EMR_SUBMITTED', 0, 20, '', '', true),
        setter: setPageSizeCompleted
      },
      {
        boardName: 'EMR Submitted Unbilled Jobs',
        apiCall: () =>
          getListofJobs('EMR_SUBMITTED_NOT_BILLED', 0, 20, '', '', true),
        setter: setPageSizeUnbilled
      },
      {
        boardName: 'EMR Submission Failed Jobs',
        apiCall: () =>
          getListofJobs('EMR_SUBMISSION_FAILED', 0, 20, '', '', true),
        setter: setPageSizeIncomplete
      },
      {
        boardName: 'Open Jobs of Last 14 Days',
        apiCall: () =>
          getListofJobs(
            openJobs,
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
        setter: setPageSizeOpen14
      },
      {
        boardName: 'EMR Submission Failed Jobs of Last 14 Days',
        apiCall: () =>
          getListofJobs(
            'EMR_SUBMISSION_FAILED',
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
        setter: setPageSizeIncomplete14
      },
      {
        boardName: 'EMR Submission Failed Jobs of Last 1 Month',
        apiCall: () =>
          getListofJobs(
            'EMR_SUBMISSION_FAILED',
            0,
            20,
            Math.floor(now - 30 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
        setter: setPageSizeIncomplete1Month
      },
      {
        boardName: 'Jobs Created',
        apiCall: () =>
          getListofJobs(
            allJobStatuses,
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
        setter: setPageSizeAllJobs
      },
      {
        boardName: 'Open Jobs for more than 7 Days',
        apiCall: () =>
          getListofJobs(
            openJobs,
            0,
            20,
            '',
            Math.floor(now - 7 * 24 * 60 * 60 * 1000),
            true
          ),
        setter: setPageSizeOpenJobsOlderThan7Days
      }
    ];

    const selectedConfigs = boardConfigs.filter(
      config => boards.find(b => b.boardName === config.boardName)?.selected
    );

    const results = await Promise.all(
      selectedConfigs.map(config => config.apiCall())
    );

    results.forEach((res, i) => {
      if (res.data.success) {
        selectedConfigs[i].setter(res.data.size);
      }
    });
  };

  const handleApply = async () => {
    setIsApplyingFilters(true);

    const systemBoards = tempBoardList.reduce((acc, board) => {
      acc[board.id] = board.selected; // true or false
      return acc;
    }, {});

    const payload = { systemBoards };

    try {
      const response = await postJobBoardsUser(payload);
      if (response.data.success) {
        setBoardList(tempBoardList);
        setLoading(true);
        getJobBoards();
        setIsDropdownVisible(false);
        notification.success({
          message: 'Boards Updated',
          description: response.data.message
        });
      } else {
        notification.error({
          message: 'Update Failed',
          description: response.data.message
        });
      }
    } catch (error) {
      console.error('Error posting job board data:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to update job board data'
      });
    } finally {
      setIsApplyingFilters(false);
    }
  };

  const menuContent = (
    <div
      style={{
        padding: 14,
        width: 220,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.12)'
      }}
    >
      <h4
        style={{
          marginBottom: 10,
          color: '#1677ff',
          fontWeight: 600,
          textAlign: 'center'
        }}
      >
        Dashboard Filters
      </h4>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8
        }}
      >
        {(tempBoardList || []).map(board => (
          <label
            key={board.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 10px',
              borderRadius: 8,
              backgroundColor: '#fff',
              cursor: 'pointer',
              boxShadow: board.selected
                ? '0 0 4px rgba(64,150,255,0.4)'
                : 'none',
              transition: 'all 0.2s ease-in-out'
            }}
          >
            <Checkbox
              checked={board.selected}
              onChange={e => handleCheckboxChange(board.id, e.target.checked)}
              style={{ margin: 0 }}
            />
            <span style={{ fontWeight: 500 }}>{board.boardName}</span>
          </label>
        ))}

        <div
          style={{
            marginTop: 10,
            textAlign: 'right'
          }}
        >
          <style>
            {`

              .apply-filter-button.ant-btn-loading .ant-btn-loading-icon .anticon {

                color: #fff !important;

              }

              .apply-filter-button.ant-btn-loading .ant-btn-loading-icon .anticon svg {

                color: #fff !important;

              }

            `}
          </style>

          <Button
            type='primary'
            size='small'
            onClick={handleApply}
            loading={isApplyingFilters}
            disabled={isApplyingFilters}
            className='apply-filter-button'
            style={{
              backgroundColor: '#1677ff',
              borderRadius: 6,
              padding: '0 16px',
              fontWeight: 500,

              color: '#fff'
            }}
          >
            {isApplyingFilters ? 'Applying' : 'Apply'}
          </Button>
        </div>
      </div>
    </div>
  );

  const openJobs = [
    'INPROGRESS_FOR_DOCTOR',
    'READY_FOR_REVIEWER',
    'INPROGRESS_FOR_REVIEWER'
  ];

  const allJobStatuses = [
    'INPROGRESS_FOR_DOCTOR',
    'READY_FOR_REVIEWER',
    'INPROGRESS_FOR_REVIEWER',
    'EMR_SUBMITTED',
    'EMR_SUBMITTED_BILLED',
    'EMR_SUBMITTED_NOT_BILLED',
    'EMR_SUBMISSION_FAILED',
    'STRUCK'
  ];

  const handleCardClick = item => {
    let tileKey = null;

    switch (item.title) {
      case 'Open Jobs':
        tileKey = 'openJobs';
        break;
      case 'EMR Submitted Jobs':
        tileKey = 'eMRSubmittedJobs';
        break;
      case 'EMR Submitted Unbilled Jobs':
        tileKey = 'eMRSubmittedUnbilledJobs';
        break;
      case 'EMR Submission Failed Jobs':
        tileKey = 'eMRSubmissionFailedJobs';
        break;
      case 'Open Jobs of Last 14 Days':
        tileKey = 'openJobsofLast14Days';
        break;
      case 'EMR Submission Failed Jobs of Last 14 Days':
        tileKey = 'eMRSubmissionFailedJobsofLast14Days';
        break;
      case 'EMR Submission Failed Jobs of Last 1 Month':
        tileKey = 'eMRSubmissionFailedJobsofLast1Month';
        break;
      case 'Jobs Created':
        tileKey = 'allJobs';
        break;
      case 'Open Jobs for more than 7 Days':
        tileKey = 'openJobsOlderThan7Days';
        break;
      default:
        return; // do nothing if title doesn't match
    }

    history.push(`/dashboard/notes-board?tile=${tileKey}&totalCount=${item.count ?? ''}`);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = Date.now();
        const [
          openJobsRes,
          completedRes,
          unbilledRes,
          incompleteJobsRes,
          openJobs14Res,
          incompleteJobs14Res,
          incompleteJobs1MonthRes,
          allJobsRes,
          openJobsOlderThan7DaysRes
        ] = await Promise.all([
          getListofJobs(openJobs, 0, 20, '', '', true),
          getListofJobs('EMR_SUBMITTED', 0, 20, '', '', true),
          getListofJobs('EMR_SUBMITTED_NOT_BILLED', 0, 20, '', '', true),
          getListofJobs('EMR_SUBMISSION_FAILED', 0, 20, '', '', true),
          getListofJobs(
            openJobs,
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
          getListofJobs(
            'EMR_SUBMISSION_FAILED',
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
          getListofJobs(
            'EMR_SUBMISSION_FAILED',
            0,
            20,
            Math.floor(now - 30 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
          getListofJobs(
            allJobStatuses,
            0,
            20,
            Math.floor(now - 14 * 24 * 60 * 60 * 1000),
            Math.floor(now),
            true
          ),
          getListofJobs(
            openJobs,
            0,
            20,
            '',
            Math.floor(now - 7 * 24 * 60 * 60 * 1000),
            true
          )
        ]);

        if (openJobsRes.data.success)
          setPageSizeOpenJobs(openJobsRes.data.size);

        if (completedRes.data.success)
          setPageSizeCompleted(completedRes.data.size);

        if (unbilledRes.data.success)
          setPageSizeUnbilled(unbilledRes.data.size);
        if (incompleteJobsRes.data.success)
          setPageSizeIncomplete(incompleteJobsRes.data.size);
        if (openJobs14Res.data.success)
          setPageSizeOpen14(openJobs14Res.data.size);
        if (incompleteJobs14Res.data.success)
          setPageSizeIncomplete14(incompleteJobs14Res.data.size);
        if (incompleteJobs1MonthRes.data.success)
          setPageSizeIncomplete1Month(incompleteJobs1MonthRes.data.size);
        if (allJobsRes.data.success) setPageSizeAllJobs(allJobsRes.data.size);
        if (openJobsOlderThan7DaysRes.data.success)
          setPageSizeOpenJobsOlderThan7Days(openJobsOlderThan7DaysRes.data.size);

        // fetch board configuration
        getJobBoards();
      } catch (error) {
        console.error('❌ Error fetching job board data:', error);
      }
    };

    if (userData.userType !== 'reviewer') {
      fetchData();
    }
  }, []);

  const getJobBoards = () => {
    getJobBoardsUser()
      .then(response => {
        if (response.data.success) {
          if (userData.userType === 'reviewer') {
            setLoading(false);
          }

          setBoardList(response.data.result[0].systemJobBoards);
          setTempBoardList(response.data.result[0].systemJobBoards);
        } else {
          if (userData.userType === 'reviewer') {
            setLoading(false);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching job board data:', error);
      });
  };
  useEffect(() => {
    if (
      pageSizeCompleted != null &&
      pageSizeUnbilled != null &&
      pageSizeOpenJobs != null
      // pageSizeInCompleteJobs != null
    ) {
      setLoading(false);
    }
  }, [
    pageSizeCompleted,
    pageSizeUnbilled,
    pageSizeOpenJobs,
    // pageSizeInCompleteJobs,
    boardList
  ]);
  const accessToken = localStorage.getItem('accessToken');
  // const userData = JSON.parse(localStorage.getItem('user'));
  useEffect(() => {
    setDashboardItems(
      dashboardContents(
        userData.userType === 'doctor'
          ? doctorPrivilege.get(userData.userPrivilege)
          : userData.userType
      )
    );
  }, []);

  useEffect(() => {}, [loading, dashboardLoading, dashboardItems]);

  const adminCount = () => {
    if (dashboardItems) {
      setLoading(true);
      if (
        // user.userType === 'cascadeGod' ||
        user.userType === 'doctor' &&
        user.userPrivilege === 'TRANSCRIPTION_REVIEWER'
      ) {
        GetAdminJobCount()
          .then(response => {
            if (response.data.success) {
              if (userData.userType === 'reviewer') {
                setLoading(false);
              }
              const counts = response.data.result[0];
              dashboardItems.map(item => {
                if (counts[item.countValue] !== undefined) {
                  item.count =
                    typeof counts[item.countValue] === 'object'
                      ? counts[item.countValue].reviewerJobCount +
                        counts[item.countValue].transcriptionistJobCount
                      : counts[item.countValue];
                } else return;
              });
              setDashboardValues([...dashboardItems]);
              setdashboardLoading(false);
            } else {
              setdashboardLoading(false);
            }
          })
          .catch(err => {
            setdashboardLoading(false);
          });
      } else {
        GetCount(
          // user.userType === 'cascadeGod' ||
          user.userType === 'doctor'
            ? doctorPrivilege.get(user.userPrivilege)
            : user.userType
        )
          .then(response => {
            if (response.data.success) {
              if (userData.userType === 'reviewer') {
                setLoading(false);
              }
              const counts = response.data.result[0];
              dashboardItems.map(
                item => (item.count = counts[item.countValue])
              );
              if (
                user.userType === 'clinicAdmin' ||
                user.userType === 'admin'
              ) {
                const transformData = input => {
                  const userData = input[0].userData;
                  const jobData = input[0].jobData;
                  const facilityData = input[0].facilityData;

                  return {
                    facilityCount: facilityData.facilityCount,
                    openJobCount: jobData.openJobsCount,
                    completedJobsCount: jobData.completedJobsCount,
                    doctorCount: userData.doctorCount,
                    transcriptionistCount: userData.transcriptionistCount,
                    reviewerCount: userData.reviewerCount,
                    adminCount: userData.adminCount
                  };
                };
                setDashboardData(
                  getSuperAdminDashboardConfig(
                    transformData(response.data.result)
                  )
                );
              } else {
                setDashboardValues([...dashboardItems]);
              }
              setdashboardLoading(false);
            } else {
              setdashboardLoading(false);
            }
          })
          .catch(err => {
            setdashboardLoading(false);
          });
      }
    }
  };

  const userNotificationDashboard = () => {
    getUserNotificationDashboard(user.id)
      .then(response => {
        if (response.data.success) {
          setFacilities(response.data.result);
          setdashboardLoading(false);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  const complianceDashboardContents = [
    {
      title: 'Jobs Created',
      countValue: 'allJobs',
      background: '#ffffff',
      iconColor: '#607D8B',
      icon: <UnorderedListOutlined />,
      count: pageSizeAllJobs,
      selected:
        boardList?.find(b => b.boardName === 'Jobs Created')?.selected || false
    },
    {
      title: 'Open Jobs',
      countValue: 'completedNotBilled',
      background: '#ffffff',
      iconColor: '#2196F3',
      icon: <FolderOpenOutlined />,
      count: pageSizeOpenJobs,
      selected:
        boardList?.find(b => b.boardName === 'Open Jobs')?.selected || false
    },
    {
      title: 'EMR Submitted Jobs',
      countValue: 'inProgress7Days',
      background: '#ffffff',
      iconColor: '#4CAF50',
      icon: <CheckCircleOutlined />,
      count: pageSizeCompleted,
      selected:
        boardList?.find(b => b.boardName === 'EMR Submitted Jobs')?.selected ||
        false
    },
    {
      title: 'EMR Submitted Unbilled Jobs',
      countValue: 'updatesNext2Weeks',
      background: '#ffffff',
      iconColor: '#FF9800',
      icon: <FileTextOutlined />,
      count: pageSizeUnbilled,
      selected:
        boardList?.find(b => b.boardName === 'EMR Submitted Unbilled Jobs')
          ?.selected || false
    },
    {
      title: 'EMR Submission Failed Jobs',
      countValue: 'inCompleteJobss',
      background: '#ffffff',
      iconColor: '#F44336',
      count: pageSizeIncomplete,
      icon: <WarningOutlined />,
      selected:
        boardList?.find(b => b.boardName === 'EMR Submission Failed Jobs')
          ?.selected || false
    },
    {
      title: 'Open Jobs of Last 14 Days',
      countValue: 'inCompleteJobss',
      background: '#ffffff',
      iconColor: '#2196F3',
      icon: <CalendarOutlined />,
      count: pageSizeOpen14,
      selected:
        boardList?.find(b => b.boardName === 'Open Jobs of Last 14 Days')
          ?.selected || false
    },
    {
      title: 'EMR Submission Failed Jobs of Last 14 Days',
      countValue: 'inCompleteJobss',
      background: '#ffffff',
      iconColor: '#E91E63',
      icon: <ClockCircleOutlined />,
      count: pageSizeIncomplete14,
      selected:
        boardList?.find(
          b => b.boardName === 'EMR Submission Failed Jobs of Last 14 Days'
        )?.selected || false
    },
    {
      title: 'EMR Submission Failed Jobs of Last 1 Month',
      countValue: 'inCompleteJobss',
      background: '#ffffff',
      iconColor: '#9C27B0',
      icon: <ExclamationCircleOutlined />,
      count: pageSizeIncomplete1Month,
      selected:
        boardList?.find(
          b => b.boardName === 'EMR Submission Failed Jobs of Last 1 Month'
        )?.selected || false
    },
    {
      title: 'Open Jobs for more than 7 Days',
      countValue: 'openJobsOlderThan7Days',
      background: '#ffffff',
      iconColor: '#FF5722',
      icon: <ClockCircleOutlined />,
      count: pageSizeOpenJobsOlderThan7Days,
      selected:
        boardList?.find(
          b => b.boardName === 'Open Jobs for more than 7 Days'
        )?.selected || false
    }
  ];

  useEffect(() => {
    userNotificationDashboard();
    // eslint-disable-next-line
  }, [notificationStatus]);

  useEffect(() => {
    adminCount();
    // eslint-disable-next-line
  }, [dashboardItems]);
  // const getBaseUrl = () => {
  //   if (process?.env?.NODE_ENV === 'development') {
  //     return 'https://dev-dictate.cascade.md/#/cross';
  //   } else if (process?.env?.NODE_ENV === 'test') {
  //     return 'https://stage-dictate.cascade.md/#/cross';
  //   } else {
  //     return 'https://dictate.cascade.md/#/cross';
  //   }
  // };
  // const handleCreateDictation = accessToken => {
  //   localStorage.setItem('dictationCreated', 'true');
  //   getTokenForUser(accessToken)
  //     .then(res => {
  //       if (res.data?.success && res.data.result[0]) {
  // 'https://jolly-grass-0a861490f-dev.eastus2.2.azurestaticapps.net/#/cross';
  // 'https://dictate.cascade.md/#/cross';
  // 'https://dev-dictate.cascade.md/#/cross';
  //'https://stage-dictate.cascade.md/#/cross';
  //         const encryptedCode = encodeURIComponent(res.data.result[0]);

  //         const finalUrl = `${getBaseUrl()}?encryptedKey=${encryptedCode}&from=create`;

  //         window.location.href = finalUrl;
  //       } else {
  //         console.error('Failed to get encrypted code from API.');
  //       }
  //     })
  //     .catch(err => {
  //       console.error('Error while calling getTokenForUser:', err);
  //     });
  // };
  const handleCreateDictation = accessToken => {
    getTokenForUser(accessToken)
      .then(res => {
        if (res.data?.success && res.data.result[0]) {
          const baseUrl = getDictationBaseUrl();
          const encryptedCode = encodeURIComponent(res.data.result[0]);

          const finalUrl = `${baseUrl}?encryptedKey=${encryptedCode}&from=create`;

          console.log('🔀 Redirecting to:', finalUrl);

          window.location.href = finalUrl;
        } else {
          console.error('Failed to get encrypted code from API.');
        }
      })

      .catch(err => {
        console.error('Error while calling getTokenForUser:', err);
      });
  };

  return loading || dashboardLoading ? (
    <Spinner />
  ) : (
    <>
      <PageTitle title='Dashboard' />
      <ContainerRow gutter={[0, 40]}>
        {/* <TitleRow span={24}>
          <CustomTypography color={theme['@text-color']}>
            Hello {user && user.firstName + ' ' + user.lastName}
          </CustomTypography>
        </TitleRow> */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 10
          }}
        >
          {/* Left — Hello user */}
          <CustomTypography color={theme['@text-color']}>
            Hello {user && user.firstName + ' ' + user.lastName}
          </CustomTypography>
          {userData.userType !== 'reviewer' && (
            <Dropdown
              trigger={['click']}
              dropdownRender={() => menuContent}
              open={isDropdownVisible}
              onOpenChange={setIsDropdownVisible}
            >
              <AddButton
                type='default'
                shape='circle'
                icon={<SettingOutlined />}
                style={{
                  fontSize: '30px',
                  fontWeight: '600',
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  border: `1px solid ${theme['@primary-color']}`,
                  color: theme['@primary-color'],
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor =
                    theme['@primary-color'];
                  e.currentTarget.style.color = '#fff';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.color = theme['@primary-color'];
                }}
              />
            </Dropdown>
          )}
        </div>

        <Col span={24}>
          {userData?.userType !== 'reviewer' && (
            <Row gutter={[30, 30]} style={{ marginBottom: 20, marginLeft: 8 }}>
              <Col>
                <StyledPrimaryButton
                  onClick={() => handleCreateDictation(accessToken)}
                >
                  Create Dictation
                </StyledPrimaryButton>
              </Col>
            </Row>
          )}

          {/* <TitleRow span={24}>
            <CustomTypography color={theme['@text-color']}>
              Compliance Dashboard
            </CustomTypography>
          </TitleRow> */}

          {userData?.userType !== 'reviewer' && (
            <Row gutter={[30, 30]}>
              {complianceDashboardContents
                .filter(item => item.selected)
                .map(item => (
                  <Col
                    xxl={6}
                    xl={8}
                    lg={8}
                    md={12}
                    sm={12}
                    xs={24}
                    key={item.title}
                  >
                    {/* <ComplianceCard item={item} /> */}
                    <div
                      onClick={() => handleCardClick(item)}
                      style={{
                        cursor:
                          item.title === 'Completed Notes - Not Billed'
                            ? 'pointer'
                            : 'default'
                      }}
                    >
                      <ComplianceCard item={item} />
                    </div>
                  </Col>
                ))}
            </Row>
          )}
          <Row gutter={[30, 30]}>
            {
              // eslint-disable-next-line
              user.userType === 'clinicAdmin' || user.userType === 'admin' ? (
                <StyledDashboardCardContainer>
                  {dashboardData.map(item => {
                    return <DashboardCard item={item} key={item.heading} />;
                  })}
                </StyledDashboardCardContainer>
              ) : (
                dashboardValues.map(item => {
                  if (
                    !(
                      item.title === 'Reviewers' &&
                      user.transcriptionFlow === 'TRANSCRIPTION_ONLY'
                    ) &&
                    !(
                      (user.userType === 'reviewer' ||
                        user.userType === 'transcriptionist') &&
                      item.countValue === 'myJobs'
                    )
                  ) {
                    return (
                      <Col xxl={5} xl={8} lg={8} md={12} sm={12} xs={24}>
                        <Link to={item.path}>
                          <MediumCard theme={theme} item={item} />
                        </Link>
                      </Col>
                    );
                  }
                })
              )
            }
          </Row>
        </Col>
        {facilities.length > 0 && (
          <>
            <TitleRow span={24}>
              <CustomTypography color={theme['@text-color']}>
                Facility
              </CustomTypography>
            </TitleRow>

            <StyledFCardContainer>
              <Row gutter={[24, 24]}>
                {facilities
                  .filter(item => item.facility.disabled === false)
                  .map(item => (
                    <FacilityStatusCard
                      clinicFacilityStatus={{
                        facilityId: item.facility.facilityId,
                        facilityName: item.facility.facilityName,
                        facilitySubcriptionExpiredOn:
                          item.facility.facilityExpireDate,
                        emrHandlingData: item.emrHandlingData
                      }}
                      userNotificationDashboard={userNotificationDashboard}
                      key={item.facility.facilityName}
                    />
                  ))}
              </Row>
            </StyledFCardContainer>
          </>
        )}
      </ContainerRow>
    </>
  );
};
export default Dashboard;
